"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenSessionStorageKeys = void 0;
/**
 * Token session storage dictionary
 */
let TokenSessionStorageKeys = exports.TokenSessionStorageKeys = /*#__PURE__*/function (TokenSessionStorageKeys) {
  /**
   * Public access session storage key
   */
  TokenSessionStorageKeys["PUBLIC_ACCESS"] = "PublicToken";
  /**
   * User access session storage key
   */
  TokenSessionStorageKeys["USER_ACCESS"] = "AuthToken";
  return TokenSessionStorageKeys;
}({});
//# sourceMappingURL=TokenSessionStorageKeys.js.map